import { sortByDate } from "../functions/sortByDate";
import useSourceFlowCollection from "./useSourceFlowCollection";
import data from "../.sourceflow/testimonials.json";

export const useTestimonials = ({ limit = null } = {}) => {
  const collection = sortByDate(useSourceFlowCollection(data), "publish_date");

  if (limit) {
    return collection.slice(0, limit);
  }

  return collection;
};

export default useTestimonials;
